<script setup>
  const props = defineProps({
    value: {
      type: String,
      default: ''
    }
  })

  const { data } = await useAsyncData(`mdc-${props.value}`, () => parseMarkdown(props.value))
</script>

<template>
  <MDCRenderer v-if="data" :body="data.body" :data="data.data" class="prose max-w-none" />
</template>
